import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UtilitiesService } from 'src/app/services/utilities.service';
import * as theGlobals from 'src/app/shared/globals';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  title = 'app';
  displayState = {
    isTestSystem: false
    };
    isLoggedIn: boolean;
    secLevel: 5;
    authProvider = theGlobals.setEnv().authProvider;
    versionNum = theGlobals.versionNum;
    copyYear = new Date().getFullYear();    // copyright year

  constructor(private router: Router, private route: ActivatedRoute, private utilService: UtilitiesService,
              private msalService: MsalService) {  }

    ngOnInit() {
      if (this.authProvider === 0) {
        this.isLoggedIn = true;
        this.router.navigate(['/home']);
      } else if (this.authProvider === 1) {
        this.connectToAD();
      }
      /*
        if (this.utilService.isUserValidated() === true) {
            this.isLoggedIn = true;
            this.router.navigate(['/home']);
        } else {
            this.isLoggedIn = false;
            this.router.navigate(['/login']);
        }
       */
  }
  connectToAD() {
    this.utilService.doAudit(this.msalService.instance.getActiveAccount(), 'current AD active account:');
    this.msalService.instance.handleRedirectPromise().then(
      res => {
        this.utilService.doAudit(res,'result from AzureAD Redirect:');
        if (res != null && res.account != null) {
          this.msalService.instance.setActiveAccount(res.account);
          // this.myUserFullName = this.msalService.instance.getActiveAccount().name;
          // this.myUsername = this.msalService.instance.getActiveAccount().username;
          // this.myUsername = this.myUsername.split('@')[0];
          this.router.navigate(['/home']);

        }
      });
  }
  isLoggedInAD() : boolean {
    return this.msalService.instance.getActiveAccount() != null;
  }

  /* DEPRECATED
    login() {
      // should we do a getBernie() here??
  }

    applySecurity() {
        // enable/disable menu, menu items, etc. depending in user Role
        // this will be done by applying (or deleting?) a class to all elements currently assigned these classes: nav-item dropdown
    }

    securityCheck(level) {
        if (level > this.secLevel) { return true; }
        else { return false; }
    }
  paymentPortal() {
    let xUrl = 'https://testing.heartlandpaymentservices.net/MerchantView/Account/Login.aspx';  // to Hearland TEST system
    // let xUrl = 'https://heartlandpaymentservices.net/MerchantView/Account/Login.aspx';        // to Hearland PROD system
    window.open(xUrl, '_payment portal'); // Note: user will be prompted for credentials; we do NOT want to include them here...
    return false; // returning false disables linking of href (defined in template), i.e. we open a new window and nothing happens to original window/page
  }
  */
}
